import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay/classic';
import DocumentTitle from 'react-document-title';

import Panel from 'app/components/shared/Panel';
import PageHeader from 'app/components/shared/PageHeader';
import Icon from 'app/components/shared/Icon';

import Chooser from './chooser';
import Row from './row';

class PipelineTeamIndex extends React.Component {
  static propTypes = {
    pipeline: PropTypes.shape({
      name: PropTypes.string.isRequired,
      organization: PropTypes.object.isRequired,
      teams: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              id: PropTypes.string.isRequired
            }).isRequired
          }).isRequired
        )
      }).isRequired
    }).isRequired,
    relay: PropTypes.object.isRequired
  };

  render() {
    return (
      <DocumentTitle title={`Teams · ${this.props.pipeline.name}`}>
        <div>
          <PageHeader>
            <PageHeader.Icon>
              <Icon
                icon="teams"
                // This icon needs to be slightly smaller
                style={{ width: 34, height: 34, marginTop: 3, marginLeft: 3 }}
              />
            </PageHeader.Icon>
            <PageHeader.Title>
              Teams
            </PageHeader.Title>
            <PageHeader.Description>
              Control which teams have access to this pipeline.
            </PageHeader.Description>
          </PageHeader>

          <div className="mb3">
            <Chooser
              pipeline={this.props.pipeline}
              onChoose={this.handleTeamChoose}
            />
          </div>

          <Panel>
            {this.renderRows()}
          </Panel>
        </div>
      </DocumentTitle>
    );
  }

  renderRows() {
    if (this.props.pipeline.teams.edges.length > 0) {
      return this.props.pipeline.teams.edges.map((edge) => {
        return (
          <Row
            key={edge.node.id}
            teamPipeline={edge.node}
            organization={this.props.pipeline.organization}
          />
        );
      });
    }

    return (
      <Panel.Section>
        <p className="dark-gray">This Pipeline has not been added to any teams yet.</p>
      </Panel.Section>
    );
  }

  handleTeamChoose = () => {
    this.props.relay.forceFetch();
  };
}

export default Relay.createContainer(PipelineTeamIndex, {
  fragments: {
    pipeline: () => Relay.QL`
      fragment on Pipeline {
        name
        ${Chooser.getFragment('pipeline')}
        organization {
          ${Row.getFragment('organization')}
        }
        teams(first: 500) {
          edges {
            node {
              id
              ${Row.getFragment('teamPipeline')}
            }
          }
        }
      }
    `
  }
});
